import { swRequest } from "@sourcewhale/shared/src/svelte/api/sw-request";

export const logNote = (body) =>
  swRequest({
    path: "/api/notes/save",
    method: "POST",
    body,
  });
